// 其他信息
import { i18n } from '@/common/utils/i18n'
import { get } from 'lodash-es'

export default (state) => {
  let bankFlow = get(state, 'currentContractorDetail.contractorInfo.extraInfo.bankFlow', {})
  return {
    title: i18n.gettext('银行流水单'),
    content: [
      {
        title: i18n.gettext('附件说明'),
        label: bankFlow.desc
      },
      {
        title: i18n.gettext('附件照片'),
        content: i18n.gettext('查看'),
        isLink: true,
        arrow: true,
        pics: bankFlow.pics
      }
      // {
      //   title: i18n.gettext('附件文件'),
      //   content: i18n.gettext('查看'),
      //   isLink: true,
      //   arrow: true,
      //   pics: bankFlow.files
      // }
    ]
  }
}
